export class ObjectDataRequest {
    imei: string;
}